import { useQuery } from "@tanstack/react-query";
import { Folder as FolderIcon } from "lucide-react";
import { api } from "../lib/api";

interface Props {
  value: string | null;
  onChange: (folderId: string | null) => void;
  disabled?: boolean;
}

/**
 * Dropdown zum Einsortieren der Note in einen Ordner.
 * Der Top-Level-Ordner ist gleichzeitig die Kategorie im Brain-Graph.
 */
export function FolderSelect({ value, onChange, disabled }: Props) {
  const { data: folders } = useQuery({
    queryKey: ["folders"],
    queryFn: () => api.listFolders(),
  });

  // Hierarchisch geordnete Optionen mit Einrückung pro Ebene
  const options: { id: string; label: string }[] = [];
  const all = folders ?? [];
  const walk = (parentId: string | null, depth: number) => {
    for (const f of all.filter((x) => x.parent_id === parentId)) {
      options.push({ id: f.id, label: `${" ".repeat(depth * 3)}${f.name}` });
      walk(f.id, depth + 1);
    }
  };
  walk(null, 0);

  return (
    <label className="flex shrink-0 items-center gap-1.5 text-xs text-zinc-400" title="Ordner = Kategorie im Graph">
      <FolderIcon className="h-3.5 w-3.5 text-zinc-500" />
      <select
        value={value ?? ""}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value === "" ? null : e.target.value)}
        className="max-w-44 rounded border border-zinc-700 bg-zinc-900 px-1.5 py-0.5 text-xs text-zinc-200 focus:border-emerald-500 focus:outline-none disabled:opacity-40"
      >
        <option value="">Kein Ordner</option>
        {options.map((o) => (
          <option key={o.id} value={o.id}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}
